import { render, staticRenderFns } from "./memberTagAdd.vue?vue&type=template&id=4b7deea4&scoped=true&"
import script from "./memberTagAdd.vue?vue&type=script&lang=js&"
export * from "./memberTagAdd.vue?vue&type=script&lang=js&"
import style0 from "./memberTagAdd.vue?vue&type=style&index=0&id=4b7deea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7deea4",
  null
  
)

component.options.__file = "memberTagAdd.vue"
export default component.exports